import { Field } from "./kit";

/**
 * The goal form's fields, shared by `NewGoalSheet` (#1219, D283) and
 * `EditGoalSheet` (#1509, D405) so the two sheets cannot drift: the title,
 * Category, Horizon, Due date and Notes controls, with their test ids.
 */

export const CATEGORIES = [
  ["technical", "Technical"],
  ["tactical", "Tactical"],
  ["physical", "Physical"],
  ["mental", "Mental"],
  ["batting", "Batting"],
  ["bowling", "Bowling"],
  ["fielding", "Fielding"],
  ["general", "General"],
];

const SELECT_STYLE = {
  width: "100%",
  height: "var(--nw-size-control)",
  padding: "0 12px",
  background: "var(--nw-surface)",
  border: "1px solid var(--nw-line)",
  borderRadius: "var(--nw-radius-control)",
  fontSize: 15,
  color: "var(--nw-ink)",
  fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
};

export const TEXTAREA_STYLE = {
  width: "100%",
  padding: 12,
  background: "var(--nw-surface)",
  border: "1px solid var(--nw-line)",
  borderRadius: "var(--nw-radius-control)",
  fontSize: 15,
  lineHeight: 1.45,
  color: "var(--nw-ink)",
  fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
};

export function SelectField({ id, label, value, onChange, testId, children }) {
  return (
    <div>
      <label htmlFor={id} className="nw-label" style={{ marginBottom: 4, display: "block" }}>
        {label}
      </label>
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} style={SELECT_STYLE}>
        {children}
      </select>
    </div>
  );
}

/** The goal title, which posts as both `goal_title` and `target`. `error` is the line under the field. */
export function GoalTitleField({ value, onChange, error }) {
  return (
    <Field
      id="goal-target"
      label="Goal title"
      data-testid="goal-target"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="e.g. Increase strike rate vs spin"
      error={error || null}
    />
  );
}

export function GoalCategoryField({ value, onChange }) {
  return (
    <SelectField id="goal-category" label="Category" value={value} onChange={onChange} testId="goal-category">
      {CATEGORIES.map(([v, l]) => (
        <option key={v} value={v}>
          {l}
        </option>
      ))}
    </SelectField>
  );
}

export function GoalHorizonField({ value, onChange }) {
  return (
    <SelectField id="goal-horizon" label="Horizon" value={value} onChange={onChange} testId="goal-horizon">
      <option value="short">Short-term</option>
      <option value="long">Long-term</option>
    </SelectField>
  );
}

export function GoalDueDateField({ value, onChange }) {
  return <Field label="Due date" type="date" data-testid="goal-date" value={value} onChange={(e) => onChange(e.target.value)} />;
}

export function GoalNotesField({ value, onChange }) {
  return (
    <div>
      <label htmlFor="goal-notes" className="nw-label" style={{ marginBottom: 4, display: "block" }}>
        Notes
      </label>
      <textarea
        id="goal-notes"
        data-testid="goal-notes"
        rows={2}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="nw-kit-input"
        style={TEXTAREA_STYLE}
      />
    </div>
  );
}
